import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLazyGetNextPlaceQuery } from "src/api/services/patientApi";
import { VisitType } from "src/api/types";
import Loading from "src/components/Loading/Loading";

interface Props {
  visitType?: VisitType;
  productId?: number;
  queryParams?: string;
}

const AuthQueue = ({
  visitType = "Initial",
  productId,
  queryParams = "",
}: Props) => {
  const [getNextPlace] = useLazyGetNextPlaceQuery();
  const navigate = useNavigate();

  useEffect(() => {
    const navigateNextPlace = async () => {
      const { data } = await getNextPlace({
        visit_type: visitType,
        product_id: productId || undefined,
      });

      if (data) {
        navigate(`${data}${queryParams}`);
      }
    };
    navigateNextPlace();
  }, [navigate, getNextPlace, visitType, productId, queryParams]);

  if (visitType === "Upsell") {
    return;
  }

  return <Loading />;
};

export default AuthQueue;
